export default __webpack_public_path__ + "static/media/logout.7ef34a53.svg";